import React, { useEffect, useState, useContext } from "react";
import LandingHeader from "../../components/LandingHeader/Header";
import LandingFooter from "../../components/footer/LandingFooter";
import { contentContext } from "../../context/contentContext";
import { useLocation, useNavigate } from "react-router-dom";
const Licensing = () => {
    const [config, setConfig] = useState({});
    const navigate = useNavigate();
    const { menus, setContentSearchFlag, inactiveFlag, setInactiveFlag, contentSearchFlag, clientData, setClientData, setRoute } = useContext(contentContext);
    let img = window.app.img;
    useEffect(() => {
        if (window.site) {
            setConfig(window.site);

        }

    }, [window.site]);



    if (config.common && config.common.imagesCDN) {
        img = config.common.imagesCDN;
    }
    const handleAll = () => {
        navigate("/faq");
        window.scrollTo(0, 0);
    }
    return (
        <>
            <LandingHeader />

            <section className="production-hero-section ">
                <div className="production-hero-bg">
                    <img src={`${img}orasi/client/resources/orasiv1/images/f6da0913b6ca7aa036c7825ebecec69dc44ec127.png`} alt="Background"
                        className="production-bg-img" />
                </div>

                <div className="container-fluid production-hero-container">
                    <div className="production-hero-content d-flex flex-column align-items-center text-center justify-content-center">
                        <div className="production-hero-text-wrapper">
                            <p className="production-hero-subtitle" data-aos="fade-up" data-aos-duration="1000">AI Licensing</p>
                            <h1 className="production-hero-title" data-aos="fade-up" data-aos-duration="1400">No story ever truly ends.</h1>
                            <p className="production-hero-description" data-aos="fade-up" data-aos-duration="1800">
                                Orasi turns unsold or archived content into new revenue streams by licensing to AI companies — with $3M+ already paid out to partners.
                            </p>
                        </div>

                        <button className="custom-btn-primary " data-aos="fade-up" data-aos-duration="2200" onClick={() => { navigate("/contactus"); window.scrollTo(0, 0); }}>
                            Unlock AI Revenues
                            <span className="material-icons">north_east</span>
                        </button>
                    </div>
                </div>
            </section>

            <section className="challenge-solution-section ">
                <div className="container-fluid challenge-solution-container">
                    <div className="row g-4">
                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1000">
                                <div className="card-header-icon">
                                    <span className="material-symbols-outlined">target</span>
                                    <h3>The Challenge</h3>
                                </div>
                                <p>After distribution windows close, most content remains idle — generating no income while still occupying storage space.</p>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="challenge-solution-card" data-aos="fade-up" data-aos-duration="1400">
                                <div className="card-header-icon">
                                    <span className="material-symbols-outlined">star</span>
                                    <h3>The Solution</h3>
                                </div>
                                <p>We connect content owners with AI companies seeking diverse datasets for training. Your archives become recurring revenue, without losing traditional rights.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="production-features-section ">
                <div className="container-fluid production-features-container">
                    <div className="features-header" data-aos="fade-up" data-aos-duration="1000">
                        <h2>From archive to asset</h2>
                    </div>

                    <div className="features-grid">
                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1000">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/licensing-img-1.png`} alt="Real-Time Budgets" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Monetize Unsold Archives</h4>
                                <p>Earn from old or unused content.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1400">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/licensing-img-2.png`} alt="AI Assistance" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Recurring Revenue</h4>
                                <p>Content can be licensed multiple times.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="1800">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/licensing-img-3.png`} alt="Tool Integrations" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Privacy & Security</h4>
                                <p>Data anonymized, SOC2-compliant.</p>
                            </div>
                        </div>

                        <div className="production-feature-card" data-aos="fade-up" data-aos-duration="2200">
                            <div className="feature-image">
                                <img src={`${img}orasi/client/resources/orasiv1/images/licensing-img-4.png`} alt="Storyboard in Seconds" className="img-fluid" />
                            </div>
                            <div className="feature-content">
                                <h4>Flexible Formats</h4>
                                <p>Raw clips, b-roll, edited content, with or without audio.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section className="target-audience-section ">
                <div className="container-fluid target-audience-container">
                    <div className="target-audience-card" data-aos="fade-up" data-aos-duration="1000">
                        <div className="row g-0">
                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>Who is this for?</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Studios with vast back catalogs.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Independent producers with unsold titles.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">task_alt</span>
                                            <p>Distributors sitting on legacy archives.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-lg-6">
                                <div className="target-section">
                                    <h3>By the number</h3>
                                    <div className="target-list">
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>$3M+ paid out to partners already.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>50,000+ hours monetized for AI training.</p>
                                        </div>
                                        <div className="target-item">
                                            <span className="material-symbols-outlined">chevron_right</span>
                                            <p>Multi-year licensing deals create long-term passive income.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className="production-cta-section ">
                <div className="production-cta-bg"></div>

                <div className="container production-cta-container">
                    <div className="production-cta-content d-flex flex-column align-items-center text-center justify-content-center">
                        <p className="cta-subtitle" data-aos="fade-up" data-aos-duration="1000">Get Started</p>
                        <h2 className="cta-title" data-aos="fade-up" data-aos-duration="1400">
                            Your archive still has value. Let’s <br className="d-none d-md-block" />
                            unlock it.
                        </h2>

                        <button className="custom-btn-primary" data-aos="fade-up" data-aos-duration="1800" onClick={() => { navigate("/contactus"); window.scrollTo(0, 0); }}>
                            Monetize through AI
                            <span className="material-icons">arrow_forward</span>
                        </button>
                    </div>
                </div>
            </section>

            <section className="faq-section">
                <div className="container-fluid faq-container">
                    <div className="faq-header">
                        <h2>Frequently Asked Questions</h2>
                    </div>

                    <div className="faq-list" id="faqAccordion">

                        {/* FAQ 1 */}
                        <div className="faq-item">
                            <div
                                className="faq-question"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq1"
                            >
                                <h4>How does AI licensing work?</h4>
                                <span className="material-icons faq-icon">expand_less</span>
                            </div>

                            <div
                                id="faq1"
                                className="collapse show"
                                data-bs-parent="#faqAccordion"
                            >
                                <div className="faq-answer">
                                    <p>
                                        Technology companies use video content to train machine learning models. Only data features are extracted—no human views the content.
                                        Models are trained for purposes such as speech-to-text, language translation, facial mapping, behavior modeling, etc.

                                        Your content will NOT be used for copying/replicating IP, cloning characters or voices, commercial resale, or any human consumption.

                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 2 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq2"
                            >
                                <h4>Where does my content go?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq2" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        Content can be submitted via Google Drive, AWS S3, or FTP. Once received, Orasi forwards it directly to the AI company for automated data extraction.


                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 3 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq3"
                            >
                                <h4>Is my IP protected?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>

                            <div id="faq3" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        Yes, absolutely. Our contract explicitly states that your IP will not be copied,
                                        cloned, reproduced, commercially reused, or human-viewed.


                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 4 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq4"
                            >
                                <h4>Can actors or voices be cloned?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div id="faq4" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        No. Cloning of characters or voices is strictly prohibited.
                                    </p>
                                </div>
                            </div>
                        </div>

                        {/* FAQ 5 */}
                        <div className="faq-item">
                            <div
                                className="faq-question collapsed"
                                data-bs-toggle="collapse"
                                data-bs-target="#faq5"
                            >
                                <h4>What is the purpose of the licensing process?</h4>
                                <span className="material-icons faq-icon">chevron_right</span>
                            </div>
                            <div id="faq5" className="collapse" data-bs-parent="#faqAccordion">
                                <div className="faq-answer">
                                    <p>
                                        The content helps train machine learning models that improve various AI capabilities.


                                    </p>
                                </div>
                            </div>
                        </div>

                       

                        <div className="d-flex justify-content-end align-items-center">
                          <a className="anchor-txt" onClick={handleAll}>View All<span className="material-icons">chevron_right</span></a>
                        </div>




                    </div>
                </div>
            </section>


            <LandingFooter menus={menus} />

        </>
    );
};

export default Licensing;
